import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FileText, 
  Download, 
  Printer,
  Clock,
  Users,
  Tag,
  MoreVertical,
  Star
} from 'lucide-react';

const ManualCard = ({ manual, onDownload, onPrint }) => {
  const getCategoryColor = (category) => {
    switch (category.toLowerCase()) {
      case 'operations': return 'blue';
      case 'safety': return 'red';
      case 'quality': return 'green';
      case 'training': return 'purple';
      default: return 'gray';
    }
  };

  const color = getCategoryColor(manual.category);

  return (
    <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all overflow-hidden border border-gray-100">
      <div className={`h-2 bg-gradient-to-r from-${color}-500 to-${color}-600`} />
      
      <div className="p-5">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg bg-${color}-50`}>
              <FileText className={`w-5 h-5 text-${color}-600`} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">{manual.title}</h3>
              <div className="flex items-center gap-2 mt-1">
                <Tag className="w-3.5 h-3.5 text-gray-400" />
                <span className="text-sm text-gray-500">{manual.category}</span>
              </div>
            </div>
          </div>
          <button className="p-1.5 hover:bg-gray-50 rounded-lg transition-colors">
            <MoreVertical className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Content Preview */}
        <div className="mb-4">
          <p className="text-sm text-gray-600 line-clamp-2">
            {manual.sections[0]?.content}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
            <Users className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-sm font-medium text-gray-900">{manual.department}</div>
              <div className="text-xs text-gray-500">Department</div>
            </div>
          </div>
          <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
            <Clock className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-sm font-medium text-gray-900">{manual.lastUpdated}</div>
              <div className="text-xs text-gray-500">Last Updated</div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t">
          <div className="flex gap-2">
            <button
              onClick={() => onPrint(manual)}
              className="p-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              title="Print Manual"
            >
              <Printer className="w-4 h-4" />
            </button>
            <button
              onClick={() => onDownload(manual)}
              className="p-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              title="Download PDF"
            >
              <Download className="w-4 h-4" />
            </button>
            <button
              className="p-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              title="Add to Favorites"
            >
              <Star className="w-4 h-4" />
            </button>
          </div>
          <Link
            to={`/sop/manuals/${manual.id}`}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
          >
            View Manual
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ManualCard;  